module.exports = __webpack_public_path__ + "img/spoken_close_14.053917bb.svg";